import { render } from "./contect.vue?vue&type=template&id=73c8fdca&scoped=true"
import script from "./contect.vue?vue&type=script&lang=js"
export * from "./contect.vue?vue&type=script&lang=js"

import "./contect.vue?vue&type=style&index=0&id=73c8fdca&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c8fdca"]])

export default __exports__